<mbs-modal
  [isCustomModal]="true"
  [title]="'wizards:schedule.additionalModal.title' | i18next">
  <ng-container
    modal-body
    [formGroup]="form">
    <mbs-form-group>
      <!-- First backup starts on -->
      <div class="row">
        <div class="col-3">
          <mbs-input-label
            class="mbs-form_label mb-0"
            [label]="'wizards:schedule.additionalModal.startFromDate' | i18next"></mbs-input-label>
        </div>
        <div class="col-3 mt-n1">
          <mbs-datepicker
            formControlName="startFromDate"
            [id]="elementSelectors.id.startFromDate"
            [needSetCurrent]="true"></mbs-datepicker>
        </div>
      </div>
      <!-- Stop Backup After -->
      <div class="row mt-3">
        <div class="col-5 pr-0">
          <mbs-checkbox
            formControlName="StopAfterEnabled"
            [id]="elementSelectors.id.stopAfterCheckbox"
            [label]="'wizards:schedule.additionalModal.stopBackupCheckbox' | i18next"
            (change)="stopAfterEnabledChangeHandler($event)"></mbs-checkbox>
        </div>
        <div class="col-2 mt-n1">
          <mbs-number
            formControlName="stopAfterHours"
            [id]="elementSelectors.id.stopAfterHours"
            [min]="0"
            (change)="stopAfterHoursChangeHandler($event)"></mbs-number>
        </div>
        <div class="col-auto">
          <mbs-input-label
            class="mbs-form_label mb-0"
            [label]="'wizards:schedule.additionalModal.hours' | i18next"></mbs-input-label>
        </div>
        <div class="col-2 mt-n1">
          <mbs-number
            formControlName="stopAfterMinutes"
            [id]="elementSelectors.id.stopAfterMinutes"
            [max]="59"
            [min]="0"></mbs-number>
        </div>
        <div class="col-auto">
          <mbs-input-label
            class="mbs-form_label mb-0"
            [label]="'wizards:schedule.additionalModal.minutes' | i18next"></mbs-input-label>
        </div>
      </div>
      <!-- Alert Backup as overdue after -->
      <div
        *ngIf="showOverdue"
        class="row mt-3"
        [id]="elementSelectors.id.alertOverdueBlock">
        <div class="col-5 pr-0">
          <mbs-checkbox
            formControlName="overdueAfterSuccessEnabled"
            [id]="elementSelectors.id.alertOverdueCheckbox"
            [label]="'wizards:schedule.additionalModal.overdueCheckbox' | i18next"
            (change)="overdueAfterSuccessChangeHandler($event)"></mbs-checkbox>
        </div>
        <div class="col-2 mt-n1">
          <mbs-number
            formControlName="overdueAfterSuccessAmount"
            [id]="elementSelectors.id.alertOverdueDays"
            [min]="1"></mbs-number>
        </div>
        <div class="col-2 mt-n1">
          <mbs-select
            formControlName="overdueAfterSuccessPeriod"
            [bindLabel]="'label'"
            [bindValue]="'value'"
            [clearable]="false"
            [hideSelected]="true"
            [id]="elementSelectors.id.alertOverduePeriod"
            [items]="overduePeriod"
            [searchable]="false"></mbs-select>
        </div>
        <div class="col-auto">
          <mbs-input-label
            class="mbs-form_label mb-0"
            [label]="'wizards:schedule.additionalModal.overduePostfix' | i18next"></mbs-input-label>
        </div>
      </div>
      <!-- Run missed Backup immediately when the computer starts up -->
      <div class="row mt-3">
        <div class="col-auto">
          <mbs-checkbox
            formControlName="ForceMissedSchedule"
            [id]="elementSelectors.id.forceMissedCheckbox"
            [label]="'wizards:schedule.additionalModal.forceMissedEnabled' | i18next"></mbs-checkbox>
        </div>
      </div>
    </mbs-form-group>
  </ng-container>

  <ng-container modalFooter>
    <button
      class="btn btn-primary"
      type="button"
      [attr.data-e2e]="elementSelectors.id.saveButton"
      [disabled]="form.invalid"
      (click)="saveClickHandler()">
      {{ 'shared:buttons.save' | i18next: { format: 'title' } }}
    </button>
    <button
      class="btn btn-secondary"
      data-dismiss="modal"
      type="button"
      [attr.data-e2e]="elementSelectors.id.cancelButton"
      (click)="cancelClickHandler()">
      {{ 'shared:buttons.cancel' | i18next: { format: 'title' } }}
    </button>
  </ng-container>
</mbs-modal>
